import { OmrHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PostErrorLogData = (errorObj, state = undefined, setState = undefined) => {
  if (state === undefined || setState === undefined) { // used to call endpoint from a react class component
    const url = `/SeriLog/LogMessage`;
    OmrHttpHelper(url, 'POST', errorObj)
      .catch((e) => {
        console.log(e);
      });
  } else if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const url = `/SeriLog/LogMessage`;
    OmrHttpHelper(url, 'POST', errorObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};


export default PostErrorLogData;